import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { StoreState } from '../../../reducers';
import Accordion from '../../Accordion';
import Checkbox from '../../Form/Checkbox';
import { setAutoCleanStaleOfflineEnabled } from '../../../containers/StaleOfflineCleanup/actions';
import { CheckboxWrapper } from '../styles';

interface StaleOfflineCleanupSettingsProps {
	dispatch: Dispatch<StoreState>;
	autoCleanEnabled: boolean;
	isVisible: boolean;
}

class StaleOfflineCleanupSettings extends React.Component<StaleOfflineCleanupSettingsProps> {
	constructor(props: StaleOfflineCleanupSettingsProps) {
		super(props);
		this.toggleAutoClean = this.toggleAutoClean.bind(this);
	}

	toggleAutoClean(): void {
		const { dispatch, autoCleanEnabled } = this.props;
		dispatch(setAutoCleanStaleOfflineEnabled(!autoCleanEnabled));
	}

	render() {
		const { autoCleanEnabled, isVisible } = this.props;

		if (!isVisible) {
			return null;
		}

		return (
			<Accordion
				title="messages.offline_downloads"
				isOpened={false}
			>
				<CheckboxWrapper>
					<Checkbox
						name="auto-clean-stale-offline"
						label={<Translate value="messages.auto_clean_stale_offline" />}
						isChecked={autoCleanEnabled}
						onChange={this.toggleAutoClean}
					/>
				</CheckboxWrapper>
			</Accordion>
		);
	}
}

export default StaleOfflineCleanupSettings;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/StaleOfflineCleanup/index.tsx